module.exports = "/_next/static/images/PayNotFound-4fe4e5899a84a91942b646afbd565cc2.svg";